export enum InternshipOfferStatusEnum {
  VISIBLE = 'visible',
  DELETED = 'deleted',
}

export enum SecureSpaceInternshipStatusEnum {
  Deleted = 'deleted',
  Pending = 'pending',
  Draft = 'draft',
  Refused = 'refused',
  Visible = 'visible',
  Archived = 'archived',
}

export const DisplaySecureSpaceInternshipStatus: Record<SecureSpaceInternshipStatusEnum, string> = {
  [SecureSpaceInternshipStatusEnum.Deleted]: 'Pourvue',
  [SecureSpaceInternshipStatusEnum.Draft]: 'Brouillon',
  [SecureSpaceInternshipStatusEnum.Pending]: 'En cours de validation',
  [SecureSpaceInternshipStatusEnum.Refused]: 'Refusée',
  [SecureSpaceInternshipStatusEnum.Visible]: 'Visible',
  [SecureSpaceInternshipStatusEnum.Archived]: 'Archivée',
};
